import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import debounce from 'lodash/debounce';

import {
  pageState,
  withPageStateProvider,
} from 'common/libs/PageState/pageState';
import { fetchAutoCompleteStation } from '../actions/busAutoCompleteStationAction';

import BusAutoCompleteStation from '../components/BusAutoCompleteStation/BusAutoCompleteStation';
import { BUS_STATION_SELECTION_TYPE_ORIGIN } from '../components/BusBookingSearchForm/BusBookingSearchForm';

const mapStateToProps = state => ({
  bookOnBehalf: state.bus.bookingSearchForm.bookOnBehalf,
  bookOnBehalfAgentId: state.bus.bookingSearchForm.agentId,
  sections: state.bus.autoCompleteStation.map(group => ({
    ...group,
    data: group.items,
  })),
});

const mapDispatchToProps = dispatch => ({
  fetchAutoCompleteStation: (
    query,
    pointAutocompleteType,
    bookOnBehalfAgentId
  ) =>
    dispatch(
      fetchAutoCompleteStation(
        query,
        pointAutocompleteType,
        bookOnBehalfAgentId
      )
    ),
});

const connectToRedux = connect(mapStateToProps, mapDispatchToProps);

@connectToRedux
@withPageStateProvider()
@pageState()
class BusAutoCompleteStationContainer extends PureComponent {
  state = {
    keyword: '',
  };

  @pageState({ error: 'snackbar.error' })
  fetchAutoComplete = () => {
    const {
      bookOnBehalf,
      bookOnBehalfAgentId,
      pointAutocompleteType,
    } = this.props;
    this.props.fetchAutoCompleteStation(
      this.state.keyword,
      pointAutocompleteType,
      pointAutocompleteType === BUS_STATION_SELECTION_TYPE_ORIGIN &&
        bookOnBehalf
        ? bookOnBehalfAgentId
        : undefined
    );
  };

  debouncedFetchAutoComplete = debounce(this.fetchAutoComplete, 300);

  handleChangeKeyword = keyword => {
    this.setState({ keyword }, () => {
      this.debouncedFetchAutoComplete(keyword);
    });
  };

  handleItemPressed = item => {
    this.props.onSelectStation(item);
    // this.props.onClose();
  };

  render() {
    const { onClose: handleClose, sections } = this.props;
    const { keyword } = this.state;

    return (
      <BusAutoCompleteStation
        sections={sections}
        onChangeKeyword={this.handleChangeKeyword}
        onClose={handleClose}
        onItemPressed={this.handleItemPressed}
        value={keyword}
      />
    );
  }
}

export default BusAutoCompleteStationContainer;
